<div class="invoice-detail-container">
    <div>
        <div class="col align-self-center">
            <div class="card pdf-viewer-container">
                <div class="card-body">
                    <div [hidden]="isError" class="pdf-viewer">
                        <ng2-pdfjs-viewer locale="fr-FR" [viewBookmark]="false" [openFile]="false" #pdfViewerMain>
                        </ng2-pdfjs-viewer>
                    </div>
                    <div [hidden]="!isError">
                        Une erreur s'est produite lors du chargement du document. Réessayez plus tard ou
                        contactez un administrateur.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-bar">
        <div fxLayout=”row” fxLayoutAlign="end">
            <div fxLayout=”row” fxLayoutAlign="end">
                <div class="btnSpacerCol">
                    <button mat-stroked-button class="currentBtn" matTooltip="Détails du document" (click)="onZoom()">
                        <mat-icon>feed</mat-icon>
                        <span class="long-btn-span large" fxHide fxShow.gt-md>Détails du document</span>
                      </button>
                </div>
                <div class="btnSpacerCol" *ngIf="!IsPickedByMe">
                    <button mat-stroked-button class="currentBtnColor" matTooltip="Traiter la facture" (click)="onPick()">
                        <mat-icon>check_circle_outline</mat-icon>
                        <span fxHide fxShow.gt-md>Traiter</span>
                      </button>
                </div>
                <div class="btnSpacerCol" *ngIf="IsPickedByMe">
                    <button mat-stroked-button class="currentBtnColor" matTooltip="Relâcher la facture" (click)="onUnpick()">
                        <mat-icon>remove_circle_outline</mat-icon>
                        <span fxHide fxShow.gt-md>Relâcher</span>
                      </button>
                </div>
                <div class="btnSpacerCol">
                    <button mat-stroked-button class="currentBtn" matTooltip="Retour" (click)="goBackToList()">
                        <mat-icon>keyboard_return</mat-icon>
                        <span class="long-btn-span" fxHide fxShow.gt-md>Retour à la liste</span>
                      </button>
                </div>
            </div>
        </div>
    </div>
</div>